import React, { useState, useEffect } from "react";

const NewEmail = ({
  id_R,
  isNewEmailOpen,
  setIsNewEmailOpen,
  newEmail,
  setNewEmail,
  handleCloseNewEmail,
  setEmailPromptOpen,
  customerEditDetails,
  setEditCustomerOpen,
}) => {
  const [isEmailValid, setIsEmailValid] = useState(false);

  useEffect(() => {
    if (isNewEmailOpen) {
      setNewEmail(customerEditDetails?.email || "");
    }
  }, [isNewEmailOpen, customerEditDetails, setNewEmail]);

  useEffect(() => {
    const validateEmailStrict = (email) => {
      if (!email) return false;

      const cleanedEmail = email?.trim()?.toLowerCase();

      const basicRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!basicRegex?.test(cleanedEmail)) return false;

      const allowedTlds = [
        "com",
        "org",
        "io",
        "co.ke",
        "ac.ke",
        "ac.rw",
        "net",
      ];

      const domainPart = cleanedEmail?.split("@")[1];

      return allowedTlds?.some((tld) => domainPart?.endsWith(`.${tld}`));
    };

    setIsEmailValid(validateEmailStrict(newEmail));
  }, [newEmail]);

  const handleClose = () => {
    setIsNewEmailOpen(false);
  };

  const handleBackButton = () => {
    handleClose();
    setEditCustomerOpen(true);
  };

  return (
    <>
      <div
        id={id_R}
        className={`${
          isNewEmailOpen ? "flex" : "hidden"
        } items-center justify-center fixed inset-0 z-50 overflow-auto bg-gray-800 bg-opacity-50`}
      >
        <div className="relative flex items-center fixed min-h-screen max-w-[100%] h-full md:h-auto">
          <div className="relative justify-end bg-white shadow max-w-[100%] mx-auto w-[55vw]">
            <div
              onClick={handleClose}
              className="absolute top-[5px] right-[10px] cursor-pointer text-[24px] flex items-center justify-center"
            >
              X
            </div>
            <div className="p-[20px]">
              <div className="flex items-center">
                <p className="text-[20px] font-bold text-[#000] mt-8">
                  Enter new email
                </p>
              </div>
              <p className="text-[#000] text-[15px] mt-5">
                Please enter the member’s new primary email for the verification
                process.
              </p>
              <div className="flex flex-col h-[50vh] mt-12">
                <div className="flex w-[70%] flex-col">
                  <label htmlFor="firstname" className="mb-[20px]">
                    Email
                  </label>
                  <div className="flex items-center gap-[15px]">
                    <input
                      type="text"
                      value={newEmail}
                      onChange={(e) => setNewEmail(e.target.value)}
                      className={`w-[70%] h-[45px] px-[10px] border-[1px] focus:outline-none ${
                        newEmail && !isEmailValid
                          ? "border-red-500"
                          : "border-[#9A9A9A]"
                      }`}
                    />
                  </div>

                  {newEmail && !isEmailValid && (
                    <p className="text-red-500 text-[13px] mt-2">
                      Please enter a valid email address.
                    </p>
                  )}
                </div>
              </div>

              <div className="flex items-center w-full mx-auto text-white justify-between">
                <button
                  onClick={handleBackButton}
                  className="h-[50px] w-[175px] bg-[#8ED6A8] rounded-[5px] text-[#000]"
                >
                  Back
                </button>
                <button
                  onClick={handleCloseNewEmail}
                  className={`h-[50px] w-[175px] rounded-[5px] text-[#FFFFFF] transition-all duration-200 ${
                    isEmailValid
                      ? "bg-[#005C53] cursor-pointer"
                      : "bg-[#D9D9D9] cursor-not-allowed"
                  }`}
                  disabled={!isEmailValid}
                >
                  Continue
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NewEmail;
